import React from "react";

export const restoreExclusions = (payload) => (payload?.filter?.and || []).filter((item) => item.operator === "neq");
export const exclusionFieldName = (item) => `${item.module || "metadata"}.${item.field}`;

export default function ReportExclusionFilters({ value = [], fields, onChange }) {
  const options = fields.filter((field) => field.dataType === "text" &&
    /^(metadata|custom_module|business_insights)\./.test(field.value));
  const update = (index, patch) => onChange(value.map((item, i) => i === index ? { ...item, ...patch } : item));
  return <div className="mt-4 border rounded p-3">
    <h4 className="font-medium text-sm">Text exclusion filters</h4>
    <p className="text-xs text-gray-500">Not equal compares exact text and keeps missing values.</p>
    {value.map((item, index) => <div key={index} className="flex gap-2 mt-2">
      <select aria-label={`Exclusion field ${index + 1}`} value={exclusionFieldName(item)} onChange={(e) => {
        const [namespace, ...parts] = e.target.value.split(".");
        update(index, { field: parts.join("."), module: namespace === "metadata" ? undefined : namespace });
      }}>
        <option value="metadata.">Select field</option>
        {!options.some((field) => field.value === exclusionFieldName(item)) && item.field ? <option value={exclusionFieldName(item)}>{exclusionFieldName(item)}</option> : null}
        {options.map((field) => <option key={field.value} value={field.value}>{field.label}</option>)}
      </select>
      <span className="text-sm self-center">Not equal</span>
      <input aria-label={`Excluded value ${index + 1}`} className="border rounded px-2" value={item.value ?? ""} onChange={(e) => update(index, { value: e.target.value })} />
      <button type="button" onClick={() => onChange(value.filter((_, i) => i !== index))}>Remove</button>
    </div>)}
    <button type="button" disabled={!options.length} className="text-indigo-600 text-sm mt-2" onClick={() => onChange([...value, { field: "", operator: "neq", value: "" }])}>Add Not equal filter</button>
  </div>;
}
